import { render, staticRenderFns } from "./ImageIconOpenCSS.vue?vue&type=template&id=4894b0c8&scoped=true&"
import script from "./ImageIconOpenCSS.vue?vue&type=script&lang=js&"
export * from "./ImageIconOpenCSS.vue?vue&type=script&lang=js&"
import style0 from "./ImageIconOpenCSS.vue?vue&type=style&index=0&id=4894b0c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894b0c8",
  null
  
)

export default component.exports